/**
* @fileoverview This file is generated by the Angular template compiler.
* Do not edit.
* @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
* tslint:disable
*/
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
/** PURE_IMPORTS_START  PURE_IMPORTS_END */
var styles = ["h1[_ngcontent-%COMP%] {\n  font-size: 45px;\n  font-weight: normal;\n  margin-top: 0; }\n  @media (max-width: 779px) {\n    h1[_ngcontent-%COMP%] {\n      font-size: 30px; } }\n\na[_ngcontent-%COMP%] {\n  color: #FFFFFF; }"];
export { styles as styles };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/modules/checkout-intro/checkout-intro.component.scss.shim.ngstyle.js
// module id = null
// module chunks = 